import React, { useMemo } from "react";
import LeftBarMenu from "../components/LeftBarMenu/LeftBarMenu";
import "./Home.css";
import ButtonRed from "../components/ButtonRed";
import { useNavigate } from "react-router-dom";

function Home() {
  const gameCards = useMemo(() => {
    const list = [];
    for (let i = 1; i <= 7; i++) {
      for (let j = 1; j <= 15; j++) {
        list.push({
          title: `Game ${j}`,
          image: `/fake-content/game-card-${j}.png`,
        });
      }
    }
    return list;
  }, []);

  const navigate = useNavigate();

  return (
    <div className='app-root-content'>
      <LeftBarMenu />
      <div className='app-full-content'>
        <div className='app-page-content'>
          <div
            style={{
              position: "relative",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <img
              src='/banner.png'
              alt='Banner'
              className='fake-content-main-page gold-border'
            />
            <div
              style={{
                position: "absolute",
                bottom: "8%",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h2>125% + 250 FS</h2>
              <div className='span'>Play & Win width Bonuses</div>
              <ButtonRed
                labelText='Join now'
                onClick={() => navigate("/game")}
              />
            </div>
          </div>
          <img
            src='/content-main-page.png'
            className='fake-content-main-page'
            alt='Main content'
          />
          <div className='fake-content-main-page fake-game-cards-wrapper'>
            {gameCards.map((card, index) => (
              <div key={index} className='fake-game-card' onClick={() => navigate("/slot")} style={{ cursor: 'pointer' }}>
                <img
                  src={card.image}
                  alt={card.title}
                  className='fake-game-card-image'
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
